export default () => ({
  tagGroups: (page: number | undefined, perPage: number | undefined) => ['tag_groups', page, perPage],
  tagGroupDetails: (group_id: number) => ['tag_groups', group_id],
  tagBranches: () => ['tag_groups', 'branches'],
});
